import { Location } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppRouteError } from '@core/entities/routing';

@Injectable({ providedIn: 'root' })
export class AppNavigationService<T = any> {
  private route = inject(Router);
  private location = inject(Location);

  navigateTo(path: T, ...entityIds: string[]): void {
    const commands = this.buildNavigationSource(path, ...entityIds);
    console.log('NAVIGATION', commands)
    this.route.navigate(commands);
  }

  navigateWithQueryParams(path: T, queryParams?: Record<string, string>): void {
    this.route.navigate([path], { queryParams: queryParams ?? {} });
  }

  buildNavigationSource(entity: T, ...entityIds: string[]): string[] {
    const hasParams = Boolean((entity as string).match(/:\w+/g)?.length);

    if (hasParams) {
      let matchCounter = 0;
      return [(entity as string).replaceAll(/:\w+/g, match => {
        if (entityIds.length < matchCounter + 1) {
          throw new AppRouteError(`Build navigation URL error: entity id for ${match} parameter is missing`);
        }

        return entityIds[matchCounter++];
      })] as string[];
    }

    return [entity] as string[];
  }

  navigateBack() {
    this.location.back();
  }
}
